<template> 
    <div>
        <ANumberKey/>
    </div>
</template>
<script>

export default {
    name: "SampleNumberKey",
}
</script>
